import React, {forwardRef} from "react";
import {ChevronDownIcon} from "../selector/SelectorIcons";
import "../selector/selector.css";

const ComboBoxSelectorTrigger = forwardRef(function ComboBoxSelectorTrigger(
    {label, open, selected, isRequiredEmpty, className, ...props},
    ref,
) {
    return (
        <button
            ref={ref}
            type="button"
            className={[
                "selector-trigger",
                "simms-drawer-trigger",
                selected ? "is-selected" : "",
                open ? "is-open" : "",
                isRequiredEmpty ? "is-required-empty" : "",
                className,
            ].filter(Boolean).join(" ")}
            role="button"
            aria-expanded={open}
            {...props}
        >
            <span className={`selector-trigger-label ${selected ? "is-selected" : ""}`}>
                {label}
            </span>
            <ChevronDownIcon className={`selector-trigger-chevron ${open ? "is-open" : ""}`} />
        </button>
    );
});

export {ComboBoxSelectorTrigger};
